export const comparisonRows = [
  { before: 'Searching for individual exercises', after: 'Open a complete scheduled workout.' },
  { before: 'Deciding how to organize the week', after: 'Follow a three-session weekly structure.' },
  { before: 'Calculating the workout timing', after: 'Use prescribed work and recovery periods.' },
  { before: 'Working out what to teach next', after: 'Follow the 26-week progression.' },
  { before: 'Creating your own tracking forms', after: 'Use the included printable trackers.' },
];
